import React from 'react';
import Helment from 'react-helmet';
import { string } from 'prop-types';
import Favicon from '../images/favicon.ico';

const HeadTag = props => (
  <Helment>
    <title>{props.title}</title>
    <link rel="icon" href={Favicon}></link>
    {props.children}
  </Helment>
)

HeadTag.propTypes = {
  title: string,
}

export default HeadTag;
